module.exports = __webpack_public_path__ + "img/pharmavite-logo.fb7fd103.jpg";